import PropTypes from 'prop-types'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

const Wizard = ({ tab, onTabSelected }) => {
    return (
        <Tabs value={tab} onChange={onTabSelected}>
            <Tab label='1. Hero Lookup' value='1' />
            <Tab label='2. Match Criteria' value='2' />
            <Tab label='3. Options' value='3' />
        </Tabs>
    )
}

Wizard.propTypes = {
    tab: PropTypes.string,
    onTabSelected: PropTypes.func
}

Wizard.defaultProps = {
    onTabSelected: () => { }
}

export default Wizard
